// extracted by mini-css-extract-plugin
export var hidden = "_4i-1";
export var leftPanel = "_4i-2";
export var readonlyInspector = "_4i-3";
export var rightPanel = "_4i-0";